var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.20246C10.8862 9.20246 9.1 11.0088 9.1 13.1464C9.1 15.284 10.8862 17.0903 13 17.0903C15.1138 17.0903 16.9 15.284 16.9 13.1464C16.9 11.0088 15.1138 9.20246 13 9.20246Z",
    fill: "#727272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4 3.94391H20.0382L16.5191 0.38519C16.3986 0.262873 16.2553 0.165869 16.0976 0.0997617C15.9399 0.0336549 15.7707 -0.000249057 15.6 1.37731e-06H10.4C10.2293 -0.000249057 10.0601 0.0336549 9.90241 0.0997617C9.74467 0.165869 9.60142 0.262873 9.4809 0.38519L5.9618 3.94391H2.6C1.1661 3.94391 0 5.12314 0 6.57318V21.0342C0 22.4842 1.1661 23.6635 2.6 23.6635H23.4C24.8339 23.6635 26 22.4842 26 21.0342V6.57318C26 5.12314 24.8339 3.94391 23.4 3.94391ZM13 19.7196C9.477 19.7196 6.5 16.709 6.5 13.1464C6.5 9.5837 9.477 6.57318 13 6.57318C16.523 6.57318 19.5 9.5837 19.5 13.1464C19.5 16.709 16.523 19.7196 13 19.7196Z",
    fill: "#727272"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d5fb578cb7bdf9a4a07c67dca75ba38c.svg";
export { ForwardRef as ReactComponent };